export { default } from './event-item';
